export enum InvestPoolState {
    NotStarted = 'NotStarted',
    InvestmentStarted = 'InvestmentStarted',
    InvestmentClosed = 'InvestmentClosed',
    StakingStarted = 'StakingStarted',
    StakingEnded = 'StakingEnded',
    Settled = 'Settled'
}